module.exports = __webpack_public_path__ + "media/log-out.935e4fa5.svg";